module.exports = __webpack_public_path__ + "static/media/street-art1080.be8404b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/background/street-art1080.jpg
// module id = 1265
// module chunks = 0